<template>
  <tippy
    :to="to"
    :theme="darkMode ? 'dark' : 'light'"
    :trigger="hoverable ? 'mouseenter' : 'click'"
    :placement="placement"
    arrow="true"
    arrow-type="round"
    animate-fill="false"
    animation="shift-away"
    interactive
  >
    <slot></slot>
  </tippy>
</template>

<script>
export default {
  props: {
    to: {
      type: String,
      default: 'span',
    },
    hoverable: {
      type: Boolean,
      default: false,
    },
    placement: {
      type: String,
      default: 'top',
    },
  },
  computed: {
    darkMode() {
      return this.$store.getters.darkMode;
    },
  },
};
</script>
